// Function to get the user's IP address
export const getUserIpAddress = async (): Promise<string> => {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (err) {
    console.error("[error at getUserIpAddress]", err);
    return ""; // Return empty string if IP address cannot be fetched
  }
};
